<template lang="html">

  	<section class="coffee-type">
		
		<div class="page-mask">
			<div class="page-wrapper">
				<div class="page-container">
					<div class="page-header">
						<slot name="header">
							<button class="btn btn-close" @click="close()">
								x
							</button>
						</slot>
					</div>

					<div class="page-body">
						<slot name="body">
							<b-container>
								<b-row class="vh-100" align-v="center">
									<b-col class="coffee-body" cols="12" md="4">
										<div class="coffee-image">
											<b-img fluid :alt="coffeeName.name" :src="require(`@/assets/coffee/` + coffeeName.image)"></b-img>
										</div>
									</b-col>
									<b-col cols="12" md="8">
										<div class="coffee-text">
											<h1 class="mb-0 pb-3">{{ coffeeName.name }}</h1>
											<div class="pt-4 coffee-body-text">
												<p>{{ coffeeName.desc }}</p>

												<p class="pt-4 nutri-val">
													Calorie : {{ coffeeName.calorie }} <br>
													Sugar : {{ coffeeName.sugar }} <br>
													Caffein : {{ coffeeName.caffein }}
												</p>
											</div>
										</div>
									</b-col>
								</b-row>
							</b-container>
						</slot>
					</div>
				</div>
			</div>
		</div>
			
  </section>

</template>

<script lang="js">

  export default  {
    name: 'coffee-type',
    props: [ 'coffeeName' ],
    mounted () {

    },
    data () {
      return {

      }
    },
    methods: {
		close() {
			this.$emit('close');
		}
    },
    computed: {

    }
}


</script>

<style scoped lang="scss">

	@import '@/assets/styles/index.scss';

	.coffee-type {

		font-family: 'Quicksand', sans-serif;
		font-size: 20px;
		
	}

  	.page-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: table;
		transition: opacity 0.3s ease;
		overflow-y: auto;
	}

	.page-wrapper {
		display: table-cell;
		vertical-align: middle;
	}

	.page-container {
		height: 100vh;
		margin: 0px auto;
		background-color: rgba($color: #242020, $alpha: 0.95);
		transition: all 0.3s ease;
    	overflow-y: auto;
	}

	.page-header {
		position: absolute;
		top: 10px;
		right: 30px;

		.btn-close {
			color: white;
			font-size: 50px;
			line-height: 50px;

			font-weight: 300;

			padding-bottom: 50px;

			transition: transform 0.2s ease;

			&:hover {
				transform: scale(1.2);

				transition: transform 0.2s ease;
			}

			&:focus {
				outline:none !important;
				outline-width: 0 !important;
				box-shadow: none;
				-moz-box-shadow: none;
				-webkit-box-shadow: none;
			} 
    
		}
		
	}

	.page-body {
		
		color: white;
		//margin: 20px 0;

		h1 {
			font-family: 'Poiret One', cursive;
			font-size: 60px;
		}

		@media (max-width: 450px) {
			.coffee-body {
				margin: 80px 0 0 0;
			}
		}
		
	}

	.coffee-image {
		background-color: $brown;
		overflow: hidden;
		max-width: 420px;
		height: auto;
		margin: 0 auto;

		padding: 10px 40px;
		border-radius: 30px;
	}

	.coffee-text {
		padding-left: 2rem;

		@media (max-width: 450px) {
			padding-left: 1rem;
			padding-right: 1rem;
        }
	}

	.coffee-body-text {

		p {
			&.nutri-val {

				font-size: 20px;

			}
		} 
		
	}

	#square {
		margin: 0 auto;
		width: 100%;
		padding-top: 100%;
		padding-bottom: 100%;
		position: relative;
	}

	.page-default-button {
		float: right;
	}

</style>
